// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5324":"837ed110","6527":"35583def","6891":"94cbccd3"}[chunkId] + ".js";
};